import {
    MobileHeaderIconContainer,
    MobileHeaderWrapper
} from "widgets/hud/ui/styles";
import { MenuIcon } from "shared/ui/icons/menuIcon";
import { SearchIcon } from "shared/ui/icons/searchIcon";
import { useHudOverlay } from "widgets/hud/model/overlayStore";
import MobileMenuModal from "widgets/mobileMenuModal/ui/MobileMenuModal";
import { useScrollHide } from "shared/lib/hooks/useScrollHide";
import React from "react";
import { useOutletColorStore } from "entities/outletColor/model/store";

export const MobileHeader: React.FC = () => {
    const toggle = useHudOverlay(s => s.toggle);
    const outletColor = useOutletColorStore(s => s.currentColor);

    const isHidden = useScrollHide(24, 6);

    return (
        <>
            <MobileHeaderWrapper $hidden={isHidden} $bg={outletColor}>
                <MobileHeaderIconContainer
                    onPointerDown={(e) => e.stopPropagation()}
                    onMouseDown={(e) => e.stopPropagation()}
                    onClick={() => toggle("mobile-menu-modal")}
                >
                    <MenuIcon />
                </MobileHeaderIconContainer>

                <MobileHeaderIconContainer
                    onPointerDown={(e) => e.stopPropagation()}
                    onMouseDown={(e) => e.stopPropagation()}
                    onClick={() => toggle("search")}
                >
                    <SearchIcon />
                </MobileHeaderIconContainer>
            </MobileHeaderWrapper>

            <MobileMenuModal />
        </>
    );
};

export default MobileHeader;
